/**
 * BMAT Layout Module
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PasswordInputComponent } from './bm-password.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PasswordInputComponent],
  exports: [PasswordInputComponent],
})
export class PasswordInputComponentModule {}
